import actions from "./actions"

const initialState = {
    invoicesAll: [],
    invoiceDetails: {}
};

export default function invoicesReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_ALL_INVOICES_DATA:
            return {...state, invoicesAll: action.payload};
        case actions.SET_INVOICES_DETAILS:
            return {...state, invoiceDetails: action.payload};
        case actions.SET_INIT_INVOICES_DETAILS:
            return {...state, invoiceDetails: {}};
        case actions.SET_INVOICES_DETAILS_BY_ADMIN:
            return {...state, invoiceDetails: action.payload};
        case actions.SET_INITIAL_INVOICES_DATA:
            return {...state, invoicesAll: []};
        default:
            return state;
    }
}